import {LABEL_LABEL_SIZE_GET , LABEL_LABEL_SIZE_SUCCESS,LABEL_LABEL_SIZE_FAILURE } from './actions';

const initialState = {
    order: {}
}

export function OrderHistoryListReducer(state = initialState, action) {
   
    if(action.type === LABEL_LABEL_SIZE_GET) {
        return state;
    }
    if(action.type === LABEL_LABEL_SIZE_SUCCESS) {
        return {
            ...state,
            order: {
                isLoaded: true,
                data: action.payload,
                message: 'Success'
            }
        }
    }
    if(action.type === LABEL_LABEL_SIZE_FAILURE) {
        return {
            ...state,
            order: {
                data: [],
                isError: true,
                message: action.payload
            }
        }
    }
    return state;
}

